import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {Paddock} from "src/app/infrastructure/moovement-api/models/asset";
import {removeAllEntities, removeEntity, setAllEntities, setEntity, withEntities} from "@ngrx/signals/entities";

interface PaddockStoreState {
  loading: boolean;
  selectedPaddock: Paddock | undefined;
}

const initialState: PaddockStoreState = {
  loading: true,
  selectedPaddock: undefined
};

export const PaddockStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<Paddock>(),
  withMethods((store) => ({
    removePaddock(id: string) {
      patchState(store, removeEntity(id));
    },
    reset() {
      patchState(store, removeAllEntities(), initialState);
    },
    setAllPaddocks(paddocks: Paddock[]) {
      patchState(store, setAllEntities(paddocks), { loading: false });
    },
    setPaddock(paddock: Paddock) {
      patchState(store, setEntity(paddock));
    },
    setSelectedPaddock(paddock: Paddock | undefined): void {
      patchState(store, { selectedPaddock: paddock });
    }
  }))
);
